import { diffChars, diffSentences, diffWords } from 'diff';
import * as React from 'react';
import { IconWithText } from './compositeComponents/compositeIcons/IconWithText';
import { TooltipTheOneWrapper } from './TooltipTheOne';

type FieldChangePanelProps = {
    children:React.ReactNode
}
export function FieldChangePanel(props:FieldChangePanelProps):JSX.Element
{
    return (
        <TooltipTheOneWrapper tooltipContent={props.children} positioning="absolute" display='inline-block'>
            <IconWithText icon="warning" variant={'warning'}>Ændret!</IconWithText>
        </TooltipTheOneWrapper>
    );
}


type SimpleFieldChangePanelProps = {
    oldValue:string,
    newValue:string,
    defaultOpen?:boolean
}
export function SimpleFieldChangePanel(props:SimpleFieldChangePanelProps):JSX.Element
{
    return (
        <>
            {props.oldValue !== props.newValue &&
                <FieldChangePanel>
                    <s>{props.oldValue || '*ingen værdi*' }</s> er ændret til <b>{props.newValue || '*ingen værdi*'}</b>
                </FieldChangePanel>
            }
        </>
    );
}


type TextFieldChangePanelProps = {
    oldText:string,
    newText:string,
    diffMode?: 'characters' | 'words' | 'sentences',
    defaultOpen?:boolean
}
export function TextFieldChangePanel(props:TextFieldChangePanelProps):JSX.Element
{
    let changes = []
    if(props.diffMode === 'characters')
        changes = diffChars(props.oldText, props.newText);
    else if(props.diffMode === 'words')
        changes = diffWords(props.oldText, props.newText);
    else 
        changes = diffSentences(props.oldText, props.newText);

    let __html = '';
    for(let i=0; i<changes.length; i++)
    {
        const change = changes[i];
        if(change.added)
            __html += `<b>${change.value}</b>`;
        else if(change.removed)
            __html += `<s>${change.value}</s>`;
        else
            __html += change.value;
    }
    return (
        <>
            {changes.some(c => c.added || c.removed) &&
                <FieldChangePanel>
                    <div dangerouslySetInnerHTML={{__html}}></div>
                </FieldChangePanel>
            }
        </>
    );
}